import { Route } from 'vue-router'
import routes from './routes'

export default (to:Route, callback:Function) => {

  if (!to.matched.length) {
    const error = {
      message: "Invalid route selected."
    }
    return callback(error)
  }

  const route = routes.find(route => route.path == to.matched[to.matched.length -1].path)

  if (route !== undefined) {

    let authenticated = false
    let permitted = false

    const scope = localStorage.getItem('idTokenScope') || ""
    const expires = Number(localStorage.getItem("idTokenExpires"))

    if (expires > Date.now()) {
      authenticated = true
    }
    
    permitted = !route.requireAuth || route.permissions.every(permission => {
      return scope.indexOf(permission) > -1 || scope.indexOf(`${permission.split(":")[0]}:super`) > -1
    })
    return callback(null, authenticated, permitted)

  } else {
    const error = {
      message: "Invalid route selected."
    }
    return callback(error)
  }

}
